import { render } from "./deletecategory.vue?vue&type=template&id=24240545"
import script from "./deletecategory.vue?vue&type=script&lang=js"
export * from "./deletecategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__